{
  "storageUnavailable": "Le navigateur ne peut pas conserver le brouillon local. Gardez cette fenêtre ouverte jusqu’à confirmation de l’enregistrement.",
  "conflict": "La progression a changé sur un autre appareil. Comparez les deux versions avant de continuer.",
  "connection": "La connexion est interrompue. Votre brouillon attend son enregistrement.",
  "notConfigured": "L’hébergement de cette activité n’est pas encore prêt. Prévenez votre professeur.",
  "preview": "Aperçu privé : aucun résultat d’étudiant n’est enregistré.",
  "loading": "Ouverture de l’activité…",
  "retry": "Réessayer l’enregistrement",
  "local": "Votre saisie sur cet appareil : ",
  "server": "Version enregistrée : ",
  "useServer": "Reprendre la version enregistrée",
  "keepLocal": "Enregistrer ma saisie à la place"
}
